import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ComisionistasView from "./pages/ComisionistasView";
import ComisionistaPerfilView from "./pages/ComisionistaPerfilView";
import ComisionistasRankingView from "./pages/ComisionistasRankingView";

export default function Comisionistas() {
  return (
    <Routes>
      <Route path="/"           element={<ComisionistasView />} />
      <Route path="/:id/perfil" element={<ComisionistaPerfilView />} />
      <Route path="/ranking"    element={<ComisionistasRankingView />} />
      <Route path="*"           element={<Navigate to="." replace />} />
    </Routes>
  );
}
